import { Component } from '@angular/core';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.scss']
})
export class CatalogueComponent {

  catalogues:any = [];
  selectedCatalogue:any = null;
  showDialog = false;

  constructor(public api:ApiService) { }

  ngOnInit(){
    this.api.post("SPDO=select",{database:'catalogue', orderBy:'position'}).then((res:any)=>{
      if(res && res.data){
        this.catalogues = res.data;
      }
    });
  }

  openFlipbook(item: any) {
    this.selectedCatalogue = item;
    this.showDialog = true;
  }

  closeFlipbook() {
    this.selectedCatalogue = null;
    this.showDialog = false;
  }
}
